import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ClientModel } from 'src/app/core/models/members/client/client.model';
import { ClientModalComponent } from '../../../shared/modals/client-modal/client-modal.component';
import { EntityTypeEnum } from '../../enums/entity-type-id-enum';

@Injectable({
  providedIn: 'root'
})
export class ClientModalService {

  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(model?: any, other?: any, activeTab?: number, disableEditing?: boolean, entityType?:EntityTypeEnum) {
    var modalRef!: NgbModalRef;
        if(model == null){
          model = new ClientModel(); 
        }
        if(entityType == undefined){
          entityType = EntityTypeEnum.Client;
        }
        modalRef = this.modalService.open( ClientModalComponent, { windowClass : "customModalClassUnderName",size: 'xl', centered: false, backdrop: 'static', keyboard: false });
        modalRef.componentInstance.model = model;
        modalRef.componentInstance.passedClientId = other; 
        modalRef.componentInstance.activeTab = activeTab;
        modalRef.componentInstance.entityTypeId = entityType;
        if(disableEditing != undefined){
          modalRef.componentInstance.disableInputs = disableEditing;
        }
        var sub: Subscription =  modalRef.closed.subscribe(()=>{
          if(modalRef.componentInstance.model.date && modalRef.componentInstance.model.date.to == ''){
            modalRef.componentInstance.model.date.to = modalRef.componentInstance.model.date.from;
          }
          this.modelChanged.emit(modalRef.componentInstance.model)
          sub.unsubscribe();
        })
  }
}
